import { RuleId } from '@wix/a11y-rules';
export const createComponentTypeMap = (elements, failedElements) => {
  const componentTypeMap = new Map();
  failedElements.forEach(element => {
    const {
      type: compType
    } = element;
    if (!componentTypeMap.has(compType)) {
      componentTypeMap.set(compType, {
        element_count: 0,
        failed_element_count: 0
      });
    }
    const currentData = componentTypeMap.get(compType);
    const updatedData = {
      element_count: currentData.element_count + 1,
      failed_element_count: currentData.failed_element_count + 1
    };
    componentTypeMap.set(compType, updatedData);
  });
  elements.forEach(element => {
    const {
      type: compType
    } = element;
    const isFailed = failedElements.some(failed => failed.id === element.id);
    if (!isFailed) {
      if (!componentTypeMap.has(compType)) {
        componentTypeMap.set(compType, {
          element_count: 0,
          failed_element_count: 0
        });
      }
      const currentData = componentTypeMap.get(compType);
      const updatedData = {
        element_count: currentData.element_count + 1,
        failed_element_count: currentData.failed_element_count
      };
      componentTypeMap.set(compType, updatedData);
    }
  });
  return componentTypeMap;
};
export const createGenericElementsData = componentTypeMap => {
  return Array.from(componentTypeMap.entries()).map(_ref => {
    let [compType, counts] = _ref;
    return {
      comptype: compType || 'unknown',
      element_count: counts.element_count,
      failed_element_count: counts.failed_element_count
    };
  });
};
export const createManualTaskData = (elements, failedElements) => {
  const componentTypeMap = createComponentTypeMap(elements, failedElements);
  const genericElementsData = createGenericElementsData(componentTypeMap);
  const elementCount = Math.max(elements.length, failedElements.length);
  return {
    elementCount,
    failedElementCount: failedElements.length,
    genericElementsData: JSON.stringify(genericElementsData),
    manualElementCount: elementCount,
    manualFailedElementCount: failedElements.length,
    taskName: RuleId.INACCESSIBLE_COMPONENTS
  };
};
//# sourceMappingURL=inaccessible-components-analytics.js.map